import { Button, Container, FormControl, Grid, TextField, Accordion, AccordionDetails, AccordionSummary, FormHelperText, Typography } from "@mui/material";
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useEffect, useState } from "react";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getPoolList } from "../../store/actions/breakDownTasksActions";
import { getShifts } from "../../store/actions/ShiftActions";
import { getAreaList, getMaintenanceType } from "../../store/actions/PMActions";
import AreaGroup from "../../components/Dropdowns/AreaGroup/AreaGroup";
import Pool from "../../components/Pool/Pool";
import Autocomplete from "@mui/material/Autocomplete";
import RecurrencePopup from "../../components/Popup/RecurrencePopup";
import RuleGenerator from "../../components/RuleGenerator/RuleGenerator";

import DatePicker, { DateObject } from "react-multi-date-picker";
import { rrulestr } from "rrule";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import DatePickerHeader from "react-multi-date-picker/plugins/date_picker_header";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";

import CheckIcon from "@mui/icons-material/Check";
import ConstructionIcon from "@mui/icons-material/Construction";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import CropSquareIcon from "@mui/icons-material/CropSquare";

import { getAllEquipmentsByAreaGroup, postCreateMultiplePM } from "../../store/actions/CreateMultiplePMActions";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
    button: {
        width: 80,
        height: 80,
        padding: 0,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
    calendarStyle: {
        borderRadius: "15px",
        border: "1px #0c8af8 solid",
        padding: "4px 12px",
        fontSize: "14px",
        backgroundColor: "aliceblue",
        boxShadow: "0 0 2px #0074d9",
    },
    accordionStyle: {
        maxHeight: "280px",
        overflowY: "auto",
        overflowX: "hidden",
    },

    treeIcons: {
        paddingTop: 7,
        color: "#1976d2",
    },
}));

const formatMultiDays = "MM/DD/YYYY";

export default function CreatePlannedMaintenance(_props) {
    const classes = useStyles();
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();
    const { pm } = useSelector((pm) => pm);
    const { breakDownTask } = useSelector((breakDownTask) => breakDownTask);
    const { CreateMultiplePM } = useSelector((CreateMultiplePM) => CreateMultiplePM);
    const { shiftList } = useSelector(({ Shifts }) => Shifts);

    //--------------------- States ---------------------
    const [poolIds, setPoolIds] = useState([]);
    const [selectedArea, setSelectedArea] = useState("");
    const [selectedAreaName, setSelectedAreaName] = useState("");
    const [days, setDays] = useState();
    const [notes, setNotes] = useState("");
    const [selectedMaintenanceType, setSelectedMaintenanceType] = useState(null);
    const [selectedMaintenanceTypeName, setSelectedMaintenanceTypeName] = useState(null);
    const [maintenanceTypes, setMaintenanceTypes] = useState([]);
    const [disableMachine, setDisableMachine] = useState(true);
    const [equipmentHierarchy, setEquipmentHierarchy] = useState([]);
    const [checked, setChecked] = useState([]);
    const [expanded, setExpanded] = useState([]);
    const [isDisable, setIsDisable] = useState(true);
    const [isHidden, setIsHidden] = useState(false);
    const [chooseDate, setchooseDate] = useState(t("ChooseMaintenanceSchedule"));
    const [recurrencePopupIsOpen, setRecurrencePopupIsOpen] = useState(false);
    const [recurrence, setRecurrence] = useState([]);
    const [ruleString, setRuleString] = useState("");
    const [ruleText, setRuleText] = useState("");
    const options = [t("ChooseMaintenanceSchedule"), t("ChooseManualDate")];


    //------------------------- Response Useeffects -------------------
    useEffect(() => {
        if (pm?.areaList?.errorCode === 0) {
            const { resultObject } = pm?.areaList;
            setAreaData(resultObject);
        }
        if (pm?.maintenanceType?.errorCode === 0) {
            setMaintenanceTypes(pm?.maintenanceType?.resultObject);
        }
    }, [pm]);

    useEffect(() => {
        if (breakDownTask?.poolList?.errorCode === 0) {
            setPoolData(breakDownTask?.poolList?.resultObject);
        }
    }, [breakDownTask]);

    useEffect(() => {
        if (CreateMultiplePM.allEquipments) {
            if (CreateMultiplePM.allEquipments.errorCode === 0) {
                setEquipmentHierarchy(CreateMultiplePM.allEquipments.resultObject);
                formatHierarchy(CreateMultiplePM.allEquipments.resultObject);
            }
        }
    }, [CreateMultiplePM.allEquipments]);

    useEffect(() => {
        if (CreateMultiplePM.createMultiplePMRes.errorCode === 0) {
            setSelectedAreaName("");
            setFormattedHierarchy([]);
            setPoolIds([]);
            setSelectedMaintenanceTypeName(null);
            setNotes("");
            setDays([new DateObject()]);
            setDisableMachine(true);
            setIsHidden(false);
        }
    }, [CreateMultiplePM.createMultiplePMRes]);

    //----------------------- Start Engine ----------------------

    useEffect(() => {
        LoadHandler();
    }, []);

    const LoadHandler = () => {
        LoadPoolData();
        LoadMaintenanceTypesData();
        LoadAreaData();
        dispatch(getShifts());
    };

    //-----------------Initial Load Areas--------------------
    let [areaData, setAreaData] = useState([]);
    const LoadAreaData = () => {
        dispatch(getAreaList());
    };

    let [poolData, setPoolData] = useState([]);
    const LoadPoolData = () => {
        dispatch(getPoolList());
    };

    const LoadMaintenanceTypesData = () => {
        dispatch(getMaintenanceType());
    };

    //---------------Handle Areas ------------------
    const HandlePoolChange = (poolName) => {
        let ids = [];
        poolName.map((item) => ids.push(item.id));
        setPoolIds(ids);
    };

    const HandleAreaFilterChange = (areaName) => {
        if (areaName != null) {
            const areaDataInfo = areaData.filter((item) => item.name === areaName);
            let areaGroupId = null;
            if (areaDataInfo[0] !== undefined) {
                areaGroupId = areaDataInfo[0].id;
            }
            setSelectedArea(areaGroupId);
            setSelectedAreaName(areaName);
            setDisableMachine(false);
            dispatch(getAllEquipmentsByAreaGroup(areaGroupId));
        } else {
            setDisableMachine(true);
            setFormattedHierarchy([]);
            setSelectedAreaName("");
        }
    };

    // Validation
    const [error, setError] = useState({
        areaGroupText: t("SelectAnAreaGroup"),
        maintenanceType: t("SelectAMaintenanceType"),
    });

    useEffect(() => {
        const newBreakdownEffectText = selectedAreaName ? "" : t("SelectAnAreaGroup");
        const newMaintenanceTypeText = selectedMaintenanceTypeName ? "" : t("SelectAMaintenanceType");

        setError({
            ...error,
            areaGroupText: newBreakdownEffectText,
            maintenanceType: newMaintenanceTypeText,
        });
    }, [selectedAreaName, selectedMaintenanceTypeName]);

    useEffect(() => {
        if (error.areaGroupText === "" && error.maintenanceType === "" && checked.length > 0) {
            setIsDisable(false);
        } else {
            setIsDisable(true);
        }
    }, [error, checked]);

    const HandleMaintenanceTypeChange = (maintenanceId) => {
        if (maintenanceId != null) {
            const filteredType = maintenanceTypes.filter((item) => item.name.includes(maintenanceId));
            setSelectedMaintenanceType(filteredType[0].id);
            setSelectedMaintenanceTypeName(filteredType[0].name);
            return filteredType[0].id;
        } else {
            setSelectedMaintenanceType(0);
            setSelectedMaintenanceTypeName("");
        }
    };

    const HandleNotes = (event) => {
        setNotes(event.target.value);
    };

    // const HandleDays = (dates) => {
    //     let days = [];
    //     dates.map((date) => {
    //         days.push(moment(date.format()).format("YYYY-MM-DD") + "T00:00:00.000Z");
    //     });
    //     setDays(days);
    // };

    let [shiftData, setShiftData] = useState([]);
    useEffect(() => {
        if (shiftList?.resultObject?.length > 0) {
            setShiftData(shiftList.resultObject[0].shifts);
        }
    }, [shiftList]);

    //-----------------Create Multiple Planned Maintenance ---------
    const createMultiplePlan = () => {
        const data = {
            poolIds: poolIds,
            maintenanceTypeId: selectedMaintenanceType || 0,
            notes: notes,
            groupIds: [],
            taskDays: getDateHandler(),
            ruleString: chooseDate === t("ChooseMaintenanceSchedule") ? ruleString : "",
            ruleText: chooseDate === t("ChooseMaintenanceSchedule") ? ruleText : "",
            equipmentIds: checked,
            shiftNo: parseInt(selectedShiftType),
        };
        //data.taskDays = data.taskDays.map((item) => new Date(item).getFullYear() + "/" + ("0" + (new Date(item).getMonth() + 1)).slice(-2) + "/" + new Date(item).getDate());
        dispatch(postCreateMultiplePM(data));
    };
    const [formattedHierarchy, setFormattedHierarchy] = useState([]);
    const formatHierarchy = (equipmentHierarchy) => {
        let i, j;
        for (i = 0; i < equipmentHierarchy.length; i++) {
            for (j = 0; j < equipmentHierarchy[i].subEquipments?.length; j++) {
                equipmentHierarchy[i].subEquipments[j].value = equipmentHierarchy[i].subEquipments[j]["id"];
                equipmentHierarchy[i].subEquipments[j].label = equipmentHierarchy[i].subEquipments[j]["name"];
                delete equipmentHierarchy[i].subEquipments[j].id;
                delete equipmentHierarchy[i].subEquipments[j].name;
            }
            equipmentHierarchy[i].value = equipmentHierarchy[i]["mainEquipmentId"];
            equipmentHierarchy[i].label = equipmentHierarchy[i]["mainEquipmentName"];
            equipmentHierarchy[i].children = equipmentHierarchy[i]["subEquipments"];
            delete equipmentHierarchy[i].mainEquipmentId;
            delete equipmentHierarchy[i].mainEquipmentName;
            delete equipmentHierarchy[i].subEquipments;
        }
        setFormattedHierarchy(equipmentHierarchy);
    };

    const [selectedShiftNo, setSelectedShiftNo] = useState("");
    const [selectedShiftType, setSelectedShiftType] = useState("");
    const HandleShift = (shiftNo) => {
        if (shiftNo != null) {
            const filteredType = shiftData.filter((item) => item.shiftNo == shiftNo);
            setSelectedShiftNo(filteredType[0].id);
            setSelectedShiftType(filteredType[0].shiftNo.toString());
            return filteredType[0].id;
        } else {
            setSelectedShiftNo(0);
            setSelectedShiftType("");
        }
    };

    const OnRecurrenceSelected = (rules, ruleString, ruleText) => {
        setRecurrence(rules);
        setRuleString(ruleString);
        setRuleText(ruleText);
        setRecurrencePopupIsOpen(false);
    };

    const DateHandler = (date) => {
        let newRules = [];
        date.forEach((element) => {
            newRules.push(element.format());
        });
        setDays(newRules);
    };

    const getDateHandler = () => {
        if (chooseDate === t("ChooseMaintenanceSchedule")) {
            return recurrence;
        } else {
            setRuleString("");
            setRuleText("");
            return days;
        }
    };

    return (
        <div>
            <Container id="cmpm_Container" fixed maxWidth="xs" style={{ marginTop: 20 }}>
                <Grid id="cmpm_Grid" container justifyContent="center" style={{ marginTop: 30 }}>
                    <Grid id="cmpm_Grid_2" item xs={12}>
                        <FormControl id="cmpm_formControl_1" variant="outlined" style={{ width: "100%" }}>
                            <AreaGroup id="cmpm_area" HandleAreaFilterChange={HandleAreaFilterChange} areaData={areaData} selectedAreaFilter={selectedAreaName} error={error} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl variant="outlined" style={{ width: "400px" }}>
                            <Accordion id="bd_accordion" disabled={disableMachine} style={{ marginTop: 15, borderColor: "red" }}>
                                <AccordionSummary id="bd_accordionSum" expandIcon={<ExpandMore id="bd_expandMore" />} aria-controls="panel1c-content">
                                    <Typography id="bd_typ_1" variant="body1" align="left">
                                        {t("Machine")}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails id="bd_accordionDet" className={classes.accordionStyle}>
                                    <CheckboxTree
                                        nodes={formattedHierarchy}
                                        checked={checked}
                                        expanded={expanded}
                                        onCheck={(checked) => {
                                            setChecked(checked);
                                            setIsHidden(checked.length > 0 ? true : false);
                                        }}
                                        onExpand={(expanded) => setExpanded(expanded)}
                                        noCascade={true}
                                        icons={{
                                            check: <CheckIcon fontSize="small" style={{ paddingTop: 7, color: "green" }} />,
                                            expandClose: <KeyboardArrowRight fontSize="small" />,
                                            uncheck: <CropSquareIcon fontSize="small" className={classes.treeIcons} />,
                                            expandOpen: <ExpandMore fontSize="small" />,
                                            parentOpen: <HomeRepairServiceIcon fontSize="small" className={classes.treeIcons} />,
                                            parentClose: <HomeRepairServiceIcon fontSize="small" className={classes.treeIcons} />,
                                            leaf: <ConstructionIcon fontSize="small" className={classes.treeIcons} />,
                                        }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                            <FormHelperText id="machineHelperText" hidden={isHidden}>
                                {t("SelectAMachine")}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid id="cmpm_Grid_3" item xs={12}>
                        <FormControl id="cmpm_formControl_2" variant="outlined" style={{ width: "100%" }}>
                            <Pool id="cmpm_pool" HandlePool={HandlePoolChange} poolData={poolData} poolIds={poolIds} />
                        </FormControl>
                    </Grid>

                    <Grid id="cmpm_Grid_4" item xs={12} style={{ marginTop: 20 }}>
                        <FormControl id="cmpm_formControl_3" variant="outlined" style={{ width: "100%" }}>
                            <Autocomplete
                                id="cpm_MaintenanceType_Autocomplete"
                                value={selectedMaintenanceTypeName}
                                defaultValue={""}
                                style={{ marginTop: -25 }}
                                onChange={(event, newValue) => {
                                    HandleMaintenanceTypeChange(newValue);
                                }}
                                options={maintenanceTypes.map((option) => option.name)}
                                renderInput={(params) => (
                                    <TextField
                                        id="cpm_TextField_4"
                                        {...params}
                                        margin="normal"
                                        label={t("MaintenanceType")}
                                        variant="outlined"
                                        error={error.maintenanceType.length > 0}
                                        helperText={error.maintenanceType}
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid id="cmpm_Grid_5" item xs={12} style={{ marginTop: 20 }}>
                        <TextField id="cmpm_TextField_1" style={{ width: "100%" }} multiline label={t("MaintenanceNote")} variant="outlined" onChange={HandleNotes} value={notes} />
                    </Grid>

                    <Grid id="cmpm_Grid_5" item xs={12} style={{ marginTop: 20 }}>
                        <FormControl id="shift_formControl" variant="outlined" style={{ width: "100%" }}>
                            <Autocomplete
                                id="cpm_Shift_Autocomplete"
                                value={selectedShiftType}
                                defaultValue={""}
                                style={{ marginTop: -25 }}
                                onChange={(event, newValue) => {
                                    HandleShift(newValue);
                                }}
                                options={shiftData.map((option) => option.shiftNo.toString())}
                                renderInput={(params) => <TextField id="cpm_TextField_5" {...params} margin="normal" label={t("Shift")} variant="outlined" />}
                            />
                        </FormControl>
                    </Grid>

                    <Grid id="cpm_Grid_11" item xs={12} style={{ marginTop: 20 }}>
                   <FormControl id="cpm_FormControl_3" variant="outlined" style={{ width: "100%" }}>
                            <Autocomplete
                                id="cpm_MaintenanceType_Autocomplete_2"
                                value={chooseDate}
                                defaultValue={""}
                                style={{ marginTop: -25 }}
                                onChange={(event, newValue) => {
                                    setchooseDate(newValue);
                                }}
                                options={options}
                                renderInput={(params) => <TextField id="cpm_TextField_4" {...params} margin="normal" label={t("DateType")} variant="outlined" />}
                            />
                        </FormControl>
                    </Grid>

                    <Grid id="cpm_Grid_7" item xs={12} style={{ marginTop: 20 }}>
                        {chooseDate !== t("ChooseManualDate") ? (
                            <Grid id="cpm_Grid_8" item xs={12}>
                                <Button id="cpm_b" style={{ marginBottom: 5, marginRight: 20 }} onClick={() => setRecurrencePopupIsOpen(true)} variant="contained" color="secondary">
                                    {t("ChooseMaintenanceSchedule")}
                                </Button>
                                <FormHelperText
                                    id="cam_FormHelperText"
                                    data-tip
                                    data-for="datesInfoText"
                                    style={{
                                        textAlign: "center",
                                        width: "150px",
                                        marginLeft: "115px",
                                        color: recurrence && recurrence.length === 0 ? "red" : "#888",
                                    }}
                                >
                                    {recurrence && recurrence.length > 0 ? `${recurrence.length}  ${t("DateSelected")}` : t("MaintenanceScheduleNotSelected")}
                                </FormHelperText>
                            </Grid>
                        ) : (
                            <Grid id="cmpm_Grid_6" item xs={12} style={{ marginTop: 20 }}>
                                <FormControl id="cmpm_formControl_4" variant="outlined" style={{ width: "90%" }}>
                                    <DatePicker
                                        id="cmpm_multidate"
                                        multiple
                                        sort
                                        placeholder={t("SelectedDates")}
                                        onChange={DateHandler}
                                        format={formatMultiDays}
                                        plugins={[<DatePanel id="cmpm_datepanel" />, <DatePickerHeader id="cmpm_date_header" position="top" size="small" />, <Toolbar position="bottom" />]}
                                        minDate={new Date()}
                                        style={{
                                            margin: 15,
                                            height: "60px",
                                            width: "90%",
                                        }}
                                        inputClass={classes.calendarStyle}
                                        calendarPosition="top"
                                        arrowClassName="custom-arrow"
                                    />
                                </FormControl>
                            </Grid>
                        )}
                    </Grid>

                    <Grid id="cmpm_Grid_7" item xs={12} style={{ marginTop: 20 }}>
                        <Button id="cmpm_b" onClick={() => createMultiplePlan()} disabled={isDisable} style={{ marginBottom: 20 }} variant="contained" color="primary">
                            {t("Save")}
                        </Button>
                    </Grid>
                </Grid>
            </Container>
            <RecurrencePopup id="cpm_rp" title={t("ChooseMaintenanceSchedule")} open={recurrencePopupIsOpen} onClose={() => setRecurrencePopupIsOpen(false)}>
                <RuleGenerator id="cpm_rg" onSubmit={OnRecurrenceSelected} rule={ruleString !== "" ? rrulestr(ruleString).origOptions : null} ruleString={ruleString} />
            </RecurrencePopup>
            <LoadingBackdrop id="cmpm_lbd" />
        </div>
    );
}
